import { render, staticRenderFns } from "./BtnVisualizarRateioRequisicao.vue?vue&type=template&id=1513f22c"
import script from "./BtnVisualizarRateioRequisicao.vue?vue&type=script&lang=js"
export * from "./BtnVisualizarRateioRequisicao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports